<template>
        <app-card title="Settings">
            <div class="pa-4" v-if="isInitDone">
                <div v-if="isControlledByEnterprise" style="margin-bottom: 16px">
                    <h3>Settings Managed By Enterprise</h3>
                    <p style="margin:8px">Your organization's settings are managed by the Enterprise organization. Contact your enterprise admin to change settings.</p>
                </div>
                <div v-if="fields">
                    
                    <div v-if="$store.getters.isOrgAdmin || $store.getters.viewingAsSuper">
                        
                        <h3>Security Preferences</h3>
                        <div class="ma-2">
                            <app-form-checkbox
                                checkbox-left-side
                                label="Require Multi-Factor Authentication"
                                v-model="fields.mfaRequired.value"
                                :helper-message="fields.mfaRequired.helperMessage"
                                :disabled="isControlledByEnterprise"
                            ></app-form-checkbox>
                            <div v-if="fields.mfaRequired.value">
                                <app-text-field
                                    type="number"
                                    label="MFA Verification Period (Days)"
                                    v-model="fields.mfaVerificationPeriod.value"
                                    :helper-message="fields.mfaVerificationPeriod.helperMessage"
                                    row
                                    style="max-width: 450px"
                                    :disabled="isControlledByEnterprise"
                                />
                            </div>
                            
                        </div>
                    </div>
                    
                    
                    <h3>Mobile Security Preferences</h3>
                    <div class="ma-2">
                        <app-form-checkbox
                            checkbox-left-side
                            label="Require PIN"
                            v-model="fields.isPasscodeEnabled.value"
                            :helper-message="fields.isPasscodeEnabled.helperMessage"
                            :disabled="isControlledByEnterprise"
                        ></app-form-checkbox>
                        
                    </div>
                    <h3>COVID-19 Settings</h3>
                    <div class="ma-2">
                        <app-form-checkbox
                            checkbox-left-side
                            label="Enable COVID-19 Screening Options"
                            v-model="fields.enableCovid19Screening.value"
                            :disabled="isControlledByEnterprise"
                            
                        ></app-form-checkbox>
                        <app-form-checkbox
                            v-if="fields.enableCovid19Screening.value"
                            checkbox-left-side
                            label="Send COVID-19 Screening alert if profile skips temperature input"
                            v-model="fields.flagTestOnCovidTemperatureSkip.value"
                            :disabled="isControlledByEnterprise"
                            
                        ></app-form-checkbox>
                        <app-form-checkbox
                            checkbox-left-side
                            label="Include Direct Contact questions in covid screening"
                            v-model="fields.enableCovidContactQuestions.value"
                            :disabled="isControlledByEnterprise"
                            
                        ></app-form-checkbox>
                    </div>
                    <div v-if="$store.getters.isSuperAdmin">
                        <h3>{{superAdminSymbol}} Internal Sway Admin Properties</h3>
                        <div class="ma-2">
                            <app-form-checkbox
                                checkbox-left-side label="Enable Fall Risk flagging"
                                v-model="fields.fallRiskStampEnabled.value"
                                :helper-message="fields.fallRiskStampEnabled.helperMessage"
                                :disabled="isControlledByEnterprise"
                            ></app-form-checkbox>
                        </div>
<!--	                    <div class="ma-2">-->
<!--		                    <app-form-checkbox-->
<!--			                    checkbox-left-side label="Is Internal Org"-->
<!--			                    v-model="fields.isInternalOrg.value"-->
<!--			                    :helper-message="fields.isInternalOrg.helperMessage"-->
<!--		                    ></app-form-checkbox>-->
<!--	                    </div>-->
	                    <div class="ma-2">
		                    <app-form-checkbox
			                    checkbox-left-side label="Enable Sports Profile Properties"
			                    v-model="fields.enableSportsProfileProperties.value"
			                    :helper-message="fields.enableSportsProfileProperties.helperMessage"
                                :disabled="isControlledByEnterprise"
		                    ></app-form-checkbox>
	                    </div>
                        <div class="ma-2">
                            <app-form-checkbox
                                checkbox-left-side label="External API Enabled"
                                v-model="fields.externalApiEnabled.value"
                                :helper-message="fields.externalApiEnabled.helperMessage"
                                :disabled="isControlledByEnterprise"
                            ></app-form-checkbox>
                        </div>
                        <div v-if="organization != null" class="ma-2">
                            <app-form-checkbox
                                    checkbox-left-side label="Profile Sharing Enabled"
                                    v-model="fields.isSwayVisaEnabled.value"
                                    :helper-message="fields.isSwayVisaEnabled.helperMessage"
                                    :disabled="isControlledByEnterprise"
                            ></app-form-checkbox>
                        </div>
                        <div v-if="organization != null" class="ma-2">
                            <app-form-checkbox
                                checkbox-left-side label="Enable Patient Account Creation"
                                v-model="fields.enablePatientAccountCreation.value"
                                :helper-message="fields.enablePatientAccountCreation.helperMessage"
                                :disabled="isControlledByEnterprise"
                            ></app-form-checkbox>
                        </div>
                    </div>

                    <!--div v-if="isEnterpriseAdminOrg()">
                        <h3>Enterprise Settings</h3>
                        <div class="ma-2">
                            <app-form-checkbox
                                    checkbox-left-side
                                    label="Replicate Organization Settings (other sections on this page) to Child Organizations within this Enterprise"
                                    v-model="fields.inheritOrganizationPreferences.value"
                                    :helper-message="fields.inheritOrganizationPreferences.helperMessage"
                                    :disabled="isControlledByEnterprise"
                            ></app-form-checkbox>
                        </div>
                        <div class="ma-2">
                            <app-form-checkbox
                                    checkbox-left-side
                                    label="Replicate Protocols to Child Organizations within this Enterprise"
                                    v-model="fields.inheritMeasuresAndProtocols.value"
                                    :helper-message="fields.inheritMeasuresAndProtocols.helperMessage"
                                    :disabled="isControlledByEnterprise"
                            ></app-form-checkbox>
                        </div>
                    </div-->
                    
                    <h3>Other Mobile App Settings</h3>
                    <div class="ma-2">
                        <app-form-checkbox checkbox-left-side
                                           label="Use Metric System"
                                           v-model="fields.isMetric.value"
                                           :disabled="isControlledByEnterprise" >
                        </app-form-checkbox>
                    </div>
                    
                    <div class="ma-2">
                        <app-form-checkbox
                                checkbox-left-side label="Skip Test Enabled"
                                v-model="fields.isSkipTestEnabled.value"
                                :helper-message="fields.isSkipTestEnabled.helperMessage"
                                :disabled="isControlledByEnterprise"
                        ></app-form-checkbox>
                    </div>
                    <div class="ma-2" >
                        <app-btn
                            @click="onFormSubmit"
                            :loading="savingChanges"
                            :disabled="isControlledByEnterprise"
                        >Save</app-btn>
                    </div>
                </div>
            </div>
        </app-card>

</template>

<script>

import {
    getOrganizationPreferences,
    updateOrganizationPreferences,
    organizationPreferencesModel
} from '@/services/organization.service'
import {SET_SNACKBAR} from "@/store/mutation-types";
import { isAdminOrgAccessType } from "@/js/shared/helper";
import { superAdminSymbol } from "@/js/shared/constants";
import { isEnterpriseAdminOrg } from "@/services/userService";
import {
    getEnterpriseOrganizations,
    getEnterprisePreferences,
    updateEnterprisePreferences,
    getParentEnterprisePreferences,
} from "@/services/enterprise.service";

export default {
    name: "OrganizationSettings",
    props: {
        organizationPreferences: {
            type: Object,
            required: true
        },
        organization: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            // fields: null,
            // organizationPreferences: null,
            savingChanges: false,
            fields: null,
            superAdminSymbol,
            isInitDone: false,
            isControlledByEnterprise: false,
        }
    },
    watch: {
        organizationPreferences() {
            this.init()
        }
    },
    async mounted() {
        this.init()
        // this.setFields()
    },
    computed: {
        
    },
    methods: {
        async init() {
            if (!this.organizationPreferences) return null
            const {
                isPasscodeEnabled,
                enableCovid19Screening,
                flagTestOnCovidTemperatureSkip,
                enableCovidContactQuestions,
                isMetric,
                mfaRequired,
                mfaVerificationPeriod,
                fallRiskStampEnabled,
                enableSportsProfileProperties,
                isSkipTestEnabled,
                externalApiEnabled,
                isSwayVisaEnabled,
                enablePatientAccountCreation
                // isInternalOrg
            } = this.organizationPreferences;
            
            this.fields = {
                mfaRequired: {
                    value: mfaRequired,
                    helperMessage: 'Require Multi-Factor Authentication when logging in.'
                },
                mfaVerificationPeriod: {
                    value: typeof mfaVerificationPeriod === 'number' ? mfaVerificationPeriod : 10,
                    helperMessage: 'The number of days between each MFA request. If set to 0, user will be required to authorize on every login attempt.'
                },
                isPasscodeEnabled: {
                    value: isPasscodeEnabled,
                    helperMessage: 'Allows organization to manage device security by requiring a local passcode on each device.'
                },
                enableCovid19Screening: {
                    value: enableCovid19Screening,
                    helperMessage: 'Enabling COVID-19 Screening Options does this that and the other thing...'
                },
                flagTestOnCovidTemperatureSkip: {
                    value: flagTestOnCovidTemperatureSkip,
                    helperMessage: 'Enabling COVID-19 Screening Alert does this that and the other thing...'
                },
                enableCovidContactQuestions: {
                    value: enableCovidContactQuestions,
                    helperMessage: 'Enabling COVID-19 Direct Contact Questions does this that and the other thing...'
                },
                isMetric: {
                    value: isMetric,
                    helperMessage: null
                },
                fallRiskStampEnabled: {
                    value: fallRiskStampEnabled,
                    helperMessage: `Dependent on the profile's age, certain test types will be flagged for high fall risk if scores fall below thresholds.`
                },
                enableSportsProfileProperties: {
                    value: enableSportsProfileProperties,
                    helperMessage: `Enables additional profile metadata fields. This includes Graduation Year, Gender Identity, Race, Primary Language, Secondary Language, Concussion History, and ADHD History.`
                },
                isSkipTestEnabled: {
                    value: isSkipTestEnabled,
                    helperMessage: `Allows tests to be skipped on this organization.`
                },
                isSwayVisaEnabled: {
                    value: isSwayVisaEnabled,
                    helperMessage: `Enables sharing profiles. Unless Patient Account Creation is also enabled, only other Sway Administrators will be able to redeem access to the profile.`
                },
                enablePatientAccountCreation:{
                    value: enablePatientAccountCreation,
                    helperMessage: `Enables Patient (or Athlete) Account creations for the organization. Enabling Patient (or Athlete) Account creation has many benefits, including but not limited to: 
Not required to re-input profile data when re-baselining, keep profile demographics up to date (height, weight, other details), and easily take remotely assigned tests.`
                },
                externalApiEnabled: {
                    value: externalApiEnabled,
                    helperMessage: `Allows users to generated external API Keys.`
                },
	            // isInternalOrg: {
                //     value: isInternalOrg,
                //     helperMessage: `Defines whether or not the Organization is an Internal Sway Org. Used for reporting purposes.`
                // },
	            //
            }
            
            if (this.isEnterpriseAdminOrg()){
                let enterprisePrefs = await getEnterprisePreferences();
                
                this.fields.inheritOrganizationPreferences = {
                    value: enterprisePrefs?.enterprisePreferences?.inheritOrganizationPreferences ?? false,
                    helperMessage: `When toggled, all child organizations in this enterprise will have the same settings (from this page). To edit organizations individually this must toggled off.`
                };
                //this.fields.inheritEhrIntegrations = {
                //    value: enterprisePrefs?.enterprisePreferences?.inheritEhrIntegrations ?? false,
                //    helperMessage: `When toggled, all child organizations in this enterprise will have the same API settings and EHR integrations. To edit organizations individually this must toggled off.`
                //};
                this.fields.inheritMeasuresAndProtocols = {
                    value: enterprisePrefs?.enterprisePreferences?.inheritMeasuresAndProtocols ?? false,
                    helperMessage: `When toggled, all child organizations in this enterprise will have the same protocols as the parent. To edit organizations individually this must toggled off.`
                };
            }
            else{
                let parentEnterprisePrefs = await getParentEnterprisePreferences();
                if (parentEnterprisePrefs?.enterprisePreferences?.inheritOrganizationPreferences){
                    this.isControlledByEnterprise = true;
                }
            }
            
            this.isInitDone = true;
        },
        isEnterpriseAdminOrg() {
            return isEnterpriseAdminOrg()
        },
        isAdminOrgAccessType(id) {
            return isAdminOrgAccessType(id)
        },
        async onFormSubmit() {
            
            const request = {...organizationPreferencesModel}
            const {organizationId, organizationPreferencesId} = this.organizationPreferences;

            const {
                isPasscodeEnabled,
                enableCovid19Screening,
                flagTestOnCovidTemperatureSkip,
                enableCovidContactQuestions,
                isMetric,
                mfaRequired,
                mfaVerificationPeriod,
                fallRiskStampEnabled,
                enableSportsProfileProperties,
                isSkipTestEnabled,
                isSwayVisaEnabled,
                enablePatientAccountCreation,
                externalApiEnabled,
                // isInternalOrg
            } = this.fields;

            request.organizationId = organizationId;
            request.organizationPreferencesId = organizationPreferencesId;

            request.mfaRequired = mfaRequired.value;
            request.mfaVerificationPeriod = mfaVerificationPeriod.value;

            request.isPasscodeEnabled = isPasscodeEnabled.value;
            request.enableCovid19Screening = enableCovid19Screening.value;
            request.flagTestOnCovidTemperatureSkip = flagTestOnCovidTemperatureSkip.value;
            request.enableCovidContactQuestions = enableCovidContactQuestions.value;
            request.isMetric = isMetric.value;
            request.fallRiskStampEnabled = fallRiskStampEnabled.value
            request.enableSportsProfileProperties = enableSportsProfileProperties.value;
            request.isSkipTestEnabled = isSkipTestEnabled.value;
            request.externalApiEnabled = externalApiEnabled.value;
            request.isSwayVisaEnabled = isSwayVisaEnabled.value;
            request.enablePatientAccountCreation = enablePatientAccountCreation.value;
            // request.isInternalOrg = isInternalOrg.value;

            this.savingChanges = true;

            const response = await updateOrganizationPreferences(request);
            if (!response.isSuccess) {
                this.savingChanges = false;
                return;
            }
            
            if (isEnterpriseAdminOrg()){
                let model = {
                    enterpriseOrganizationId: organizationId,
                    inheritOrganizationPreferences: this.fields.inheritOrganizationPreferences.value,
                    //inheritEhrIntegrations: this.fields.inheritEhrIntegrations.value,
                    inheritMeasuresAndProtocols: this.fields.inheritMeasuresAndProtocols.value,
                }
                await updateEnterprisePreferences(model)
            }

            this.savingChanges = false; // for some reason this doesn't work so we are reloading the whole page...

            this.$store.commit(SET_SNACKBAR, {
                text: 'Organization Settings Successfully Updated',
                color: 'success',
                open: true
            })

            setTimeout(100, window.location.reload());
            
            //this.$emit('setOrganizationPreferences', organizationPreferences)
            // this.organizationPreferences = organizationPreferences
        },
    },


}
</script>

<style scoped>

</style>